  import React, { useState, useContext } from "react";
  import PartyMemberTable from "./PartyMemberTable.js";
  import { useQuery, useQueryClient } from "react-query";
  import useAxiosInstance from "../../../lib/useAxiosInstance";
  import { userContext } from "../../../context/UserContextProvider";
  import { Pagination, Select } from "antd";
  import { toast } from "react-toastify";
  import SearchFilter from "../../SearchFilter";
  import { useTranslation } from "react-i18next";

  const PartyMemberList = () => {
    const { t } = useTranslation();
    const { currentPage, setCurrentPage, limit, setLimit, total, setTotal } = useContext(userContext);
    const axiosInstance = useAxiosInstance();
    const queryClient = useQueryClient();
    const [searchKeyword, setSearchKeyword] = useState("");

    const fetchMembers = async () => {
      const response = await axiosInstance.get(
        `api/directory/party-members?page=${currentPage}&limit=${limit}`
      );
      setTotal(response.data.data.totalPages);
      return response;
    };

    const partyMembersData = useQuery(["party-members", currentPage, limit], fetchMembers);
    const handleSearch = (value) => {
      setCurrentPage(1);
      setSearchKeyword(value);
    };

    const fetchSearchResults = async () => {
      if (searchKeyword) {
        const response = await axiosInstance.get(
          `api/directory/searchPM?keyword=${searchKeyword}&page=${currentPage}&limit=${limit}`
        );
        setTotal(response.data.data.totalPages);
        return response;
      } else {
        return fetchMembers();
      }
    };

    const searchResults = useQuery(
      ["party-members-search", searchKeyword, currentPage, limit],
      fetchSearchResults,
      { refetchOnWindowFocus: false }
    );

    const handleDelete = async (record) => {
      try {
        const response = await axiosInstance.delete(`api/directory/party-members/${record._id}`);
        toast.success(response.data.message);
        queryClient.invalidateQueries("party-members");
        queryClient.invalidateQueries("party-members-search");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Error deleting record");
      }
    };

    return (
      <>
        <SearchFilter handleSearch={handleSearch} />
        {/* {partyMembersData?.data?.data?.data?.results?.length === 0 && (<h1>No data available</h1>)} */}
        {/* {partyMembersData?.data?.data?.data?.results?.length !== 0 &&  */}
        <PartyMemberTable
          membersData={partyMembersData?.data?.data?.data?.results || []}
          searchResults={searchResults?.data?.data?.data || []}
          handleDelete={handleDelete}
          searchKeyword={searchKeyword}
        />
        {/*  } */}
        <div className='client-pagination mx-5 '>
          <div className='pagination-text'>
            {t("Showing")}
            <Select
              className='mx-2'
              value={limit.toString()}
              style={{ width: 56 }}
              onChange={(val) => {
                setLimit(parseInt(val));
                setCurrentPage(1);
              }}
              options={[
                { value: "10", label: "10" },
                { value: "20", label: "20" },
                { value: "50", label: "50" },
                { value: "100", label: "100" }
              ]}
            />
            {t("Entries per page")}
          </div>
          <Pagination
            current={currentPage}
            pageSize={limit}
            total={total * limit}
            onChange={(page, pageSize) => {
              setCurrentPage(page);
              setLimit(pageSize);
            }}
            className='pagination'
          />
        </div>
      </>
    );
  };

  export default PartyMemberList;
